module.exports = __webpack_public_path__ + "static/img/360mac2.c8e0970.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/extend/360mac2.png
// module id = PCnY
// module chunks = 94